import React from 'react';
import './style.css';

const WhatsAppFloat: React.FC = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5511940349594';
    const message = encodeURIComponent(
      'Olá equipe Pão e Talho, estava navegando no portal e gostaria de uma ajuda.'
    );
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className='whatsapp-float' onClick={handleWhatsAppClick}>
      <div className='whatsapp-float-content'>
        <img
          src='/assets/img/Carolino_HEAD.png'
          alt='Carolino - Suporte WhatsApp'
          className='whatsapp-float-image'
          onError={e => {
            // Fallback se a imagem não carregar
            e.currentTarget.style.display = 'none';
            const fallback = e.currentTarget.nextElementSibling as HTMLElement;
            if (fallback) {
              fallback.style.display = 'flex';
            }
          }}
        />
        <div className='whatsapp-float-fallback' style={{ display: 'none' }}>
          💬
        </div>
      </div>
      <div className='whatsapp-float-tooltip'>
        Oi, eu sou o Carolino. Como posso te ajudar?
      </div>
    </div>
  );
};

export default WhatsAppFloat;
